import { InjectionToken, StaticProvider } from '@angular/core';
import { Request, Response } from 'express';
import { LogSink } from '../services/logger.service';

export const REQUEST = new InjectionToken<Request>('express:REQUEST');
export function provideRequest(request: Request):  StaticProvider {
  return {
    provide: REQUEST,
    useValue: request,
  }
}

export const RESPONSE = new InjectionToken<Response>('express:RESPONSE');
export function provideResponse(response: Response):  StaticProvider {
  return {
    provide: RESPONSE,
    useValue: response,
  }
}

export const LOGGER_SINKS = new InjectionToken<{ [name: string]: LogSink }>('express:LOGGER_SINKS');
export function provideLoggerSinks(sinks: { [name: string]: LogSink }):  StaticProvider {
  return {
    provide: LOGGER_SINKS,
    useValue: sinks,
  }
}
